import { useState, PropsWithChildren } from "react";
import Link, { LinkProps } from "next/link";
import queryString from "query-string";

import { getUrlParams } from "shared/lib/helpers/router";
import { PropsWithClassNameI } from "shared/lib/interfaces/ui";
import { useEffectOnce } from "shared/lib/hooks";

interface UTMLinkPropsI
  extends LinkProps, PropsWithClassNameI, PropsWithChildren {
  target?: string;
}

const salesResumeParams = () => {
  if (window.location.href.includes("/sr/")) {
    const username = getUrlParams("/sr(/:username)")?.username || "";

    return username ? { referrer: username } : {};
  }

  return {};
};

export const UTMLink = ({ children, href = "", ...props }: UTMLinkPropsI) => {
  const [utmUrl, setUtmUrl] = useState(href);

  useEffectOnce(() => {
    //NOTE:
    //     To make thing simple we won't filter query and pass it as is
    //     until required otherwise

    const [baseUrl] = (href as string).split("?");

    const currentPathSearch = window.location.href.split("?")[1] || "";
    const currentPathSearchParams = queryString.parse(currentPathSearch) || {};
    const hrefSearchSearch = (href as string)?.split("?")[1] || "";
    const hrefSearchSearchParams = queryString.parse(hrefSearchSearch) || {};

    const mergedParams = {
      ...hrefSearchSearchParams,
      ...currentPathSearchParams,
      ...salesResumeParams(),
    };

    const searchString = queryString.stringify(mergedParams);

    setUtmUrl(`${baseUrl}${searchString ? `?${searchString}` : ""}`);
  });

  return (
    <Link {...props} href={utmUrl as string}>
      {children}
    </Link>
  );
};
